module.exports = __webpack_public_path__ + "static/media/icon-doctor.f8a295c7.svg";